module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAA5ElEQVRIx2NgaDlJFcTYcoK59TiQRAhSbijQROnOLQa9iz0n9hv2LmJrPUo1o5W71pbMzF2/xO7iKuXuudGOE6byte+jgtGcbYdip9afXKl5eLneqZXql1YpT5ofKt+1gQpG87btD5zceXyF9vN1gq/W859eqTFtfpBK91rquDpqatPZVWqHV+idWqVxfpUq0GjquBqINLpXls/K2rnM7Ppquanzg90mTqJOWAMRa+tRxa71xr0LgiZ3mPXN42g7RLUUAkFMLSeAdjBRN13jRD+vidEIjRpNR6MZaiJphUaNppvRAAq4J32iS+csAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/rw.png
// module id = 913
// module chunks = 0